import React from 'react';
import PropTypes from 'prop-types';
import { getConfirmEventName } from '../../helpers/week';
import { Button, Card } from 'day8-ui';
import { IoMdArrowForward } from "@react-icons/all-files/io/IoMdArrowForward";

const PlanDestinationBox = ({ destination, soldOut, selected, handleDestinationSelection, minPrice, className }) => {
  const [loading, setLoading] = React.useState(false);
  const eventName = getConfirmEventName(destination.name || "Destination", null, null);
  let buttonText = `Start plan${minPrice ? ` from ${minPrice}€` : ''}`;
  if (selected) {
    buttonText = 'Selected';
  } else if (soldOut) {
    buttonText = 'Sold Out';
  }
  if (loading) {
    buttonText = 'Selecting...';
  }
  const handleSelect = async () => {
    setLoading(true);
    await handleDestinationSelection();
    setLoading(false);
  };
  const disabled = soldOut || selected || loading;
  return (
    <Card
      className={`${className} ${handleDestinationSelection && !disabled ? 'dui-cursor-pointer dui-transition hover:dui-opacity-75' : ''} dui-h-full !dui-p-0 dui-w-full dui-relative dui-flex dui-flex-col dui-justify-between`}
      onClick={handleDestinationSelection && !disabled ? handleSelect : undefined}>
      <img className="dui-brightness-75 dui-absolute dui-z-2 dui-w-full dui-h-full dui-object-cover dui-left-0 dui-top-0" src={destination.img || "https://wpassets.theyachtweek.com/wp-content/uploads/2024/08/special-floating-festival.png"} alt={destination.name || "item sample image"} width={600} height={600} />
      {destination.dates && (
        <div className={`dui-bg-secondary-100 dui-w-full dui-relative dui-py-1 dui-px-4 dui-font-bold dui-text-primary-950 dui-uppercase dui-border-b-4 dui-border-solid dui-border-secondary-500`}>
          <div className="dui-flex dui-justify-between dui-items-center dui-gap-2">
            {destination.dates}
            {handleDestinationSelection && (
              <Button className="dui-font-body dui-font-bold" rightIcon={<IoMdArrowForward />} buttonType="LINK" disabled={disabled}>{buttonText}</Button>
            )}
          </div>
        </div>
      )}
      <div className="dui-relative dui-text-white dui-p-8">
        <h2 className="dui-text-left dui-font-heading dui-text-2xl lg:dui-text-5xl dui-uppercase dui-text-white dui-mb-2">{eventName}</h2>
      </div>
    </Card>
  );
};

PlanDestinationBox.propTypes = {
  destination: PropTypes.object.isRequired,
  handleDestinationSelection: PropTypes.func.isRequired,
  className: PropTypes.string,
  soldOut: PropTypes.bool,
  selected: PropTypes.bool
};

export default PlanDestinationBox;
